import React from 'react';
import QuickAssessment from './QuickAssessment';
const ScienceSection = () => {
  return <div className="mb-16" id="how-it-works" data-id="element-320">
      <QuickAssessment data-id="element-321" />
      <div className="mb-10" data-id="element-322">
        <h3 className="text-3xl font-bold mb-6 relative inline-block" data-id="element-323">
          How MyoQuell Works
          <span className="absolute -bottom-1 left-0 right-0 h-1 bg-green-200" data-id="element-324"></span>
        </h3>
        <div className="flex justify-center mb-8" data-id="element-325">
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/erSwpjSdPjF3un8LkGrJ7Q/Untitled_design_%286%29.png" alt="MyoQuell herbal ingredients and how they penetrate the knee" className="w-full max-w-md h-auto rounded-lg shadow-md" data-id="element-326" />
        </div>
        <div className="prose prose-xl max-w-none" data-id="element-327">
          <p className="text-xl mb-6 leading-relaxed" data-id="element-328">
            The unique blend of herbs in MyoQuell patches work synergistically
            to target inflammation and block pain signals right at the source.
          </p>
        </div>
      </div>
      <div className="mb-12" data-id="element-329">
        <h3 className="text-3xl font-bold mb-6 relative inline-block" data-id="element-330">
          You're One Decision Away
          <span className="absolute -bottom-1 left-0 right-0 h-1 bg-green-200" data-id="element-331"></span>
        </h3>
        <div className="prose prose-xl max-w-none" data-id="element-332">
          <p className="mb-6 text-xl leading-relaxed" data-id="element-333">Right now, you can:</p>
          <div className="grid md:grid-cols-2 gap-8 mb-8" data-id="element-334">
            <div className="bg-red-50 p-6 rounded-lg border-l-4 border-red-400 transform transition-transform hover:scale-[1.01]" data-id="element-335">
              <p className="font-bold text-xl mb-3" data-id="element-336">Option 1:</p>
              <p className="text-xl leading-relaxed" data-id="element-337">
                Keep taking pills that destroy your stomach. Keep missing out on
                life. Consider surgery that might not even work.
              </p>
            </div>
            <div className="bg-green-50 p-6 rounded-lg border-l-4 border-green-400 transform transition-transform hover:scale-[1.02]" data-id="element-338">
              <p className="font-bold text-xl mb-3" data-id="element-339">Option 2:</p>
              <p className="text-xl leading-relaxed" data-id="element-340">
                Try what's already working for thousands of women just like you.
              </p>
            </div>
          </div>
          <p className="text-xl leading-relaxed mb-5" data-id="element-341">
            Susan chose Option 2. Three months later, she completed a 5K charity
            walk.
          </p>
          <blockquote className="border-l-4 border-green-500 pl-6 py-4 my-8 bg-green-50 rounded-r-lg" data-id="element-342">
            <p className="italic text-xl leading-relaxed" data-id="element-343">
              "I'm not running marathons, but I'm LIVING again. Playing with
              Emma, gardening, walking with my husband. I got my life back."
            </p>
          </blockquote>
          <p className="text-xl font-bold" data-id="element-344">What will you choose?</p>
        </div>
      </div>
      <div className="bg-gray-100 p-8 rounded-lg shadow-md mb-10" id="science" data-id="element-345">
        <h3 className="text-3xl font-bold mb-5 text-gray-800" data-id="element-346">
          The Hidden Cost of Chronic Knee Pain
        </h3>
        <div className="prose prose-xl max-w-none" data-id="element-347">
          <p className="mb-6 text-xl leading-relaxed" data-id="element-348">
            What most people don't realize is how much knee pain truly costs—not
            just financially, but emotionally and socially.
          </p>
        </div>
        <div className="grid md:grid-cols-2 gap-6 mb-6" data-id="element-349">
          <div className="bg-white p-6 rounded-lg shadow-sm transform transition-transform hover:scale-[1.02]" data-id="element-350">
            <div className="flex items-center mb-3" data-id="element-351">
              <div className="w-12 h-12 rounded-full bg-green-100 flex items-center justify-center mr-4 text-green-600 font-bold text-xl" data-id="element-352">
                $
              </div>
              <p className="text-xl" data-id="element-353">
                <span className="font-bold" data-id="element-354">$3,200 annually</span> spent on
                treatments
              </p>
            </div>
          </div>
          <div className="bg-white p-6 rounded-lg shadow-sm transform transition-transform hover:scale-[1.02]" data-id="element-355">
            <div className="flex items-center mb-3" data-id="element-356">
              <div className="w-12 h-12 rounded-full bg-green-100 flex items-center justify-center mr-4 text-green-600 font-bold text-xl" data-id="element-357">
                73%
              </div>
              <p className="text-xl" data-id="element-358">
                report that pain has negatively impacted their relationships
              </p>
            </div>
          </div>
          <div className="bg-white p-6 rounded-lg shadow-sm transform transition-transform hover:scale-[1.02]" data-id="element-359">
            <div className="flex items-center mb-3" data-id="element-360">
              <div className="w-12 h-12 rounded-full bg-green-100 flex items-center justify-center mr-4 text-green-600 font-bold text-xl" data-id="element-361">
                81%
              </div>
              <p className="text-xl" data-id="element-362">
                have given up activities they once loved
              </p>
            </div>
          </div>
          <div className="bg-white p-6 rounded-lg shadow-sm transform transition-transform hover:scale-[1.02]" data-id="element-363">
            <div className="flex items-center mb-3" data-id="element-364">
              <div className="w-12 h-12 rounded-full bg-green-100 flex items-center justify-center mr-4 text-green-600 font-bold text-xl" data-id="element-365">
                65%
              </div>
              <p className="text-xl" data-id="element-366">
                experience depression related to their mobility limitations
              </p>
            </div>
          </div>
        </div>
      </div>
      <div className="border-l-4 border-yellow-500 pl-8 py-6 bg-yellow-50 rounded-r-lg mb-8 shadow-md animate-pulse" data-id="element-367">
        <div className="flex items-start mb-3" data-id="element-368">
          <div className="text-3xl text-yellow-600 mr-3" data-id="element-369">⚠️</div>
          <h3 className="font-bold text-2xl" data-id="element-370">WARNING:</h3>
        </div>
        <div className="prose prose-xl max-w-none" data-id="element-371">
          <p className="mb-4 text-xl leading-relaxed" data-id="element-372">
            We only have{' '}
            <span className="font-bold text-red-600" data-id="element-373">487 units left</span>. The
            herbs must be harvested at specific times, and we WILL sell out.
          </p>
          <p className="mb-4 text-xl leading-relaxed" data-id="element-374">
            Due to the complex sourcing of authentic herbs and the precise
            manufacturing process required, MyoQuell can only produce limited
            quantities each month.
          </p>
          <p className="text-xl leading-relaxed" data-id="element-375">
            Currently, MyoQuell is offering a special introductory discount for
            new customers, but supplies are expected to run out within the next
            <span className="font-bold text-red-600" data-id="element-376"> 48 hours</span> based on
            current order volume.
          </p>
        </div>
      </div>
      <div className="mt-8 mb-2 text-center" data-id="element-377">
        <a href="https://myoquell.com/products/escape-knee-pain-with-myoquell-herbal-patches" className="bg-gradient-to-r from-green-600 to-green-500 hover:from-green-700 hover:to-green-600 text-white w-full py-4 rounded-lg font-bold block text-center transition-colors shadow-lg text-xl" target="_blank" rel="noopener noreferrer" data-id="element-378">
          TRY MYOQUELL RISK-FREE TODAY →
        </a>
        <p className="text-center text-sm mt-1 text-gray-600" data-id="element-379">
          <span className="inline-flex items-center" data-id="element-380">
            <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-green-600 mr-2" viewBox="0 0 20 20" fill="currentColor" data-id="element-381">
              <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" data-id="element-382" />
            </svg>
            30-Day Money Back Guarantee
          </span>
        </p>
      </div>
    </div>;
};
export default ScienceSection;